var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("home")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_812a0049044848f38aa51354fd997dc3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f99186","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_812a0049044848f38aa51354fd997dc3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 